import calls from '@/backend/api-calls'

const state = () => ({
  rfqSummary: [],
  drawingHighlightSummary: [],
  estimationSummary: [],
  loading: {
    rfq: false,
    drawingHighlight: false,
    estimation: false
  },
  filters: {
    product_brand: null,
    project_id: null
  },
  statusOrders: {
    rfq: ['In Progress', 'Awaiting Estimator Review', 'Awaiting Revision', 'Accepted'],
    drawingHighlight: ['Requested', 'Awaiting Approval', 'Awaiting Revision', 'Approved'],
    estimation: ['In Progress', 'Ready for Pricing', 'Completed']
  }
})

// getters
const getters = {
}

// actions
const actions = {
  getRfqSummary: ({commit}, parameters) => {
    commit("setLoading", { field: 'rfq', value: true });

    return new Promise((resolve, reject) => {
      calls.rfqStatusSummary.get(parameters)
        .then(resp => {
          commit("setRfqSummary", resp.data);
          commit("setLoading", { field: 'rfq', value: false });
          resolve(resp);
        }).catch(err => {
          commit("setLoading", { field: 'rfq', value: false });
          reject(err);
        })
    })
  },
  getDrawingHighlightSummary: ({commit}, parameters) => {
    commit("setLoading", { field: 'drawingHighlight', value: true });

    return new Promise((resolve, reject) => {
      calls.drawingHighlightStatusSummary.get(parameters)
        .then(resp => {
          commit("setDrawingHighlightSummary", resp.data);
          commit("setLoading", { field: 'drawingHighlight', value: false });
          resolve(resp);
        }).catch(err => {
          commit("setLoading", { field: 'drawingHighlight', value: false });
          reject(err);
        })
    })
  },
  getEstimationSummary: ({commit}, parameters) => {
    commit("setLoading", { field: 'estimation', value: true });

    return new Promise((resolve, reject) => {
      calls.estimationStatusSummary.get(parameters)
        .then(resp => {
          commit("setEstimationSummary", resp.data);
          commit("setLoading", { field: 'estimation', value: false });
          resolve(resp);
        }).catch(err => {
          commit("setLoading", { field: 'estimation', value: false });
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading(state, { field, value }) {
    state.loading[field] = value;
  },
  setRfqSummary(state, data) {
    data.sort(function(a, b){  
      return state.statusOrders.rfq.indexOf(a.status) - 
        state.statusOrders.rfq.indexOf(b.status);
    });
    state.rfqSummary = data;
  },
  setDrawingHighlightSummary(state, data) {
    data.sort(function(a, b){  
      return state.statusOrders.drawingHighlight.indexOf(a.status) - 
        state.statusOrders.drawingHighlight.indexOf(b.status);
    });
    state.drawingHighlightSummary = data;
  },
  setEstimationSummary(state, data) {
    data.sort(function(a, b){  
      return state.statusOrders.estimation.indexOf(a.status) - 
        state.statusOrders.estimation.indexOf(b.status);
    });
    state.estimationSummary = data;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}